import { render, staticRenderFns } from "./DataExplorer.vue?vue&type=template&id=8dc786c0&scoped=true&"
import script from "./DataExplorer.vue?vue&type=script&lang=ts&"
export * from "./DataExplorer.vue?vue&type=script&lang=ts&"
import style0 from "./DataExplorer.vue?vue&type=style&index=0&id=8dc786c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc786c0",
  null
  
)

export default component.exports